import { g as e } from "./global.js";
import { i as t } from "./is-object.js";
var r = e.document,
  o = t(r) && t(r.createElement),
  m = function m(e) {
    return o ? r.createElement(e) : {};
  };
export { m as d };